var _rect, _g, _g2, _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreetingStyleStatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 50,
    viewBox: "0 0 106 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 88.644,
    y: 37.462,
    width: 9.826,
    height: 8.67,
    rx: 4.335,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#greeting-style--static_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.92,
    y: 33.562,
    width: 12.138,
    height: 12.138,
    rx: 2,
    fill: "#009EFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#greeting-style--static_svg__filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7a2 2 0 012-2h88a2 2 0 012 2v22a2 2 0 01-2 2H9a2 2 0 01-2-2V7z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.989,
    cy: 39.632,
    r: 3.035,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ADA9BB",
    d: "M14.08 13.219h10.115v2.023H14.08zM26.219 13.219H40.38v2.023H26.219zM87.92 20.299H73.76v2.023h14.16zM42.402 13.219h51.587v2.023H42.402zM70.724 20.299H14.08v2.023h56.644z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "greeting-style--static_svg__filter0_d",
    x: 84.92,
    y: 31.562,
    width: 18.138,
    height: 18.138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.122049 0 0 0 0 0.233071 0 0 0 0 0.770833 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "greeting-style--static_svg__filter1_d",
    x: 0,
    y: 0,
    width: 106,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default __webpack_public_path__ + "./fonts/greeting-style--static.37eac8bfb65b291166805150e1715d94.svg";
export { SvgGreetingStyleStatic as ReactComponent };